import { NAVIGATION_ITEM_TYPE } from 'constants/navigation';
import { naturalSortBy } from 'utils/sort';

import { OTHER_NAV_ITEM } from './NavigationMenu.constants';

// Overflowed top-level GROUP areas render header-less inside the "Other" flyout, so their option
// lists visually concatenate into one list. Promote each GROUP's children up (recursively) and
// re-sort the whole bucket so the flyout reads as a single alphabetical list; COLLAPSE sub-menus
// stay collapsed and sort by their own title alongside the leaf items.
const flattenOverflowGroups = items =>
  items.flatMap(item =>
    item.type === NAVIGATION_ITEM_TYPE.GROUP ? flattenOverflowGroups(item.children) : [item],
  );

// `visibleCount` is the measured number of top-level areas that fit (from useOverflowCount); the
// remainder collapse into the synthetic "Other" flyout. A non-finite count — the pre-measurement
// initial render — shows every area. The vertical sidebar scrolls, so it also surfaces every area.
// Option lists arrive already alphabetized from selectNavigationConfig.
export const getTransformedNavigation = ({ navigation, visibleCount, isVertical = false }) => {
  if (isVertical) {
    return navigation;
  }

  const indexToSplit = Number.isFinite(visibleCount) ? visibleCount : navigation.length;

  const shownItems = navigation.slice(0, indexToSplit);
  const restItems = navigation.slice(indexToSplit);

  if (restItems.length) {
    shownItems.push({
      ...OTHER_NAV_ITEM,
      children: naturalSortBy(flattenOverflowGroups(restItems), 'title'),
    });
  }

  return shownItems;
};
